module.exports = __webpack_public_path__ + "img/print_logo.4161d871.jpeg";